import {Component, HostBinding, OnDestroy} from "@angular/core";
import {FUINavLayoutService} from "../../nav-layout/nav-layout.service";
import {Subscription} from "rxjs";
import {FUINavigationService} from "../../navigation/navigation.service";

@Component({
    selector: "fui-canvas-frame",
    styleUrls: ["./canvas-frame.component.scss"],
    templateUrl: "./canvas-frame.component.html"
})
export class FUICanvasFrameComponent implements OnDestroy {
    @HostBinding("class.active") private active: boolean;
    @HostBinding("class.mobile") private get mobile() {
        return this.navigationService.useMobileNav();
    };

    private subscriptions: Subscription = new Subscription();

    constructor(private navigationService: FUINavigationService,
                private navLayoutService: FUINavLayoutService) {
        this.active = false;

        this.subscriptions.add(this.navLayoutService.activeFrame$.subscribe(
            (active) => {
                this.active = active;
            }
        ));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

}
